import { WithSubpages } from '../../subpages';
import { PAGE_TITLE } from '../../consts';
import { payoutSubpages } from '../../subpages/dictionary';

import { MAIN_PAGE_PATH } from './paths';

const Payout = () => <WithSubpages mainPagePath={MAIN_PAGE_PATH} title={PAGE_TITLE.PAYOUT} items={payoutSubpages} />;

export default Payout;
